import type { Conversation } from "~/ai-chat/model/conversation";

// Conversation id → epoch ms of the newest activity the user has seen on it.
export type ConversationReadMarks = ReadonlyMap<string, number>;

export function hasUnseenUpdate(
  marks: ConversationReadMarks,
  conversation: Pick<Conversation, "id" | "updated">,
): boolean {
  const seenAt = marks.get(conversation.id);
  return seenAt === undefined || conversation.updated.getTime() > seenAt;
}
